import React, {memo} from "react";
import {AppBar} from "@mui/material";

type Props = {};

const TopNav: React.FC<Props> = () => {
    return (
        <AppBar position={"fixed"} color={"transparent"} variant={"plain" as never} className={"pageTopNav"}>
            <div style={styles.navWrapper}>
                <div style={styles.leftSection}></div>
                <div style={styles.rightSection}></div>
            </div>
        </AppBar>
    );
};
export default memo(TopNav);

const styles = {
    navWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "15px",
        padding: "10px",
    },
    leftSection: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "15px",
        marginRight: "auto",
    },
    RightSection: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "15px",
        marginLeft: "auto",
    },
} as Record<string, React.CSSProperties>;
